module.exports = "pegasus_template/assets/theme5/medium/4.jpg";